export default {
  name: '体験・遊び・アクティビティ',
  caption: '※レンタル・隣接含む',
  children: [
    { label: 'カヌー・カヤック・SUP', value: 'activity_canoe' },
    { label: 'サウナテント', value: 'activity_tentsauna' },
    { label: '川遊び', value: 'activity_river' },
    { label: '釣り', value: 'activity_fishing' },
    { label: '海水浴', value: 'activity_sea' },
    { label: '遊具・アスレチック', value: 'activity_playset' },
  ],
};
